import { useEffect, useState } from "react";
import { RefreshCw, WifiOff } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function ConnectionStatusBanner() {
    const { authStatus } = useApp();
    const [online, setOnline] = useState(() =>
        typeof navigator === "undefined" ? true : navigator.onLine,
    );

    useEffect(() => {
        const onOnline = () => setOnline(true);
        const onOffline = () => setOnline(false);
        window.addEventListener("online", onOnline);
        window.addEventListener("offline", onOffline);
        return () => {
            window.removeEventListener("online", onOnline);
            window.removeEventListener("offline", onOffline);
        };
    }, []);

    const reconnecting = online && authStatus === "reconnecting";
    if (online && !reconnecting) return null;

    return (
        <div
            className="fixed left-1/2 top-[max(10px,env(safe-area-inset-top))] z-[120] w-[calc(100%-24px)] max-w-md -translate-x-1/2"
            role="status"
            data-testid="connection-status-banner"
        >
            <div className="flex items-center gap-3 rounded-2xl border border-amber-300/70 bg-slate-950/95 px-3.5 py-3 text-white shadow-2xl backdrop-blur-md">
                <div className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-amber-400/15 text-amber-300">
                    {online ? (
                        <RefreshCw className="h-4 w-4 animate-spin" />
                    ) : (
                        <WifiOff className="h-4 w-4" />
                    )}
                </div>
                <div className="min-w-0 flex-1">
                    <div className="text-sm font-bold">
                        {online ? "Connection is slow" : "You are offline"}
                    </div>
                    <div className="text-xs text-slate-300">
                        Your session is safe. Showing your last loaded screen.
                    </div>
                </div>
                <button
                    type="button"
                    onClick={() =>
                        window.dispatchEvent(
                            new CustomEvent("mg-retry-connection"),
                        )
                    }
                    className="shrink-0 rounded-xl bg-amber-400 px-3 py-2 text-xs font-black text-slate-950"
                >
                    Retry
                </button>
            </div>
        </div>
    );
}
